/**
 * New strings of the "Valider des textes" page, FR and EN. Existing keys of
 * translations.ts stay in use (t.validateThisText, t.transcriptionRejectionReason,
 * t.audioXofY...).
 */
export const validateTranscriptionCopy = {
  fr: {
    instructions: [
      "Écoutez l'audio en entier avant de décider.",
      "Corrigez le texte si besoin, puis validez-le.",
      "Rejetez avec un motif quand le texte ne correspond pas à ce qui est dit.",
    ],
    rejectTitle: "Rejeter le texte",
    finalize: "Finaliser",
    play: "lecture / pause",
    stepDone: "Traité",
    stepRejected: "Rejeté",
    stepTodo: "À faire",
    stepCurrent: "En cours",
    doneTitle: "Lot terminé",
    doneDescription: "Tous les textes de ce lot ont été traités. Merci pour votre relecture.",
    doneValidated: "Validés",
    doneRejected: "Rejetés",
    doneFinalized: "Finalisés",
    doneContinue: "Lot suivant",
  },
  en: {
    instructions: [
      "Listen to the whole audio before deciding.",
      "Correct the text if needed, then validate it.",
      "Reject it with a reason when the text does not match what is said.",
    ],
    rejectTitle: "Reject the text",
    finalize: "Finalize",
    play: "play / pause",
    stepDone: "Done",
    stepRejected: "Rejected",
    stepTodo: "To do",
    stepCurrent: "In progress",
    doneTitle: "Batch complete",
    doneDescription: "Every text of this batch has been handled. Thank you for reviewing.",
    doneValidated: "Validated",
    doneRejected: "Rejected",
    doneFinalized: "Finalized",
    doneContinue: "Next batch",
  },
} as const;

export type ValidateTranscriptionCopy = {
  [K in keyof (typeof validateTranscriptionCopy)['fr']]: (typeof validateTranscriptionCopy)['fr'][K] extends readonly string[]
    ? readonly string[]
    : string;
};
